const audioData: Record<
  string,
  { prefix: string; start: number; end: number }
> = {
  "icelandic-1": { prefix: "H1-", start: 1, end: 71 },
  "icelandic-2": { prefix: "H2", start: 1, end: 95 },
  "icelandic-3a": { prefix: "h3", start: 1, end: 35 },
  "icelandic-3b": { prefix: "h3", start: 36, end: 70 },
  "icelandic-4": { prefix: "H4", start: 1, end: 57 },
};

export interface AudioData {
  name: string;
  src: string;
  index: number;
}
export const getAudios = (slug: string | undefined): AudioData[] | null => {
  if (!slug) return null;
  const ad = audioData[slug];
  const audios: AudioData[] = [];
  if (ad) {
    let index = 0;
    for (let i = ad.start; i <= ad.end; i++) {
      const num = ("0" + i).slice(-2);
      const name = ad.prefix + num + ".mp3";
      const path = `loa/static/courses/${slug}/audio/${name}`;
      const src = `/app/bucket/fetch/${encodeURIComponent(path)}`;
      audios.push({ name, src, index: index++ });
    }
  }
  return audios;
};
